import React, { useState } from "react";
import Button from "./form/Button";
import Input from "./form/Input";
import useForm from "../hooks/useForm";
import useMutation from "../hooks/useMutation";
import { changeEmail, sendOtp } from "../services/ProfileService";
import { toast } from "react-toastify";
import { formValidate } from "../helpers/formValidate";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setProfile } from "../redux/slice/profileSlice";

function ChangeEmail() {
  const [isOtpInputEnable, setIsOtpInputEnable] = useState(false);
  const dispatch = useDispatch();

  const validation = {
    email: { required: true, message: "Please enter your email!" },
  };
  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({ validationRules: validation });
  const user = useSelector((state) => state?.profile?.data);
  const {
    mutate,
    error: signUpError,
    isPending: otpLoding,
  } = useMutation({
    mutationFn: async (val) => {
      if (!isOtpInputEnable) {
        return await sendOtp({
          email: val?.email,
          requestType: "EMAIL-CHANGE",
        });
      } else {
        return await changeEmail({
          email: val?.email,
          requestType: "EMAIL-CHANGE",
          confirmEmail: val?.email,
          otp: val?.otp,
        });
      }
    },
    onSuccess: async (res) => {
      if (!isOtpInputEnable) {
        if (res?.status === 200) {
          toast.success(res?.message || res?.data?.message);
          setIsOtpInputEnable(true);
        } else {
          toast?.error(res?.data?.message || "Something went wrong");
        }
      } else {
        if (res?.status === 200) {
          toast.success(res?.message || res?.data?.message);
          dispatch(setProfile({ ...user, email: res?.data?.email }));
          localStorage.setItem("auth_token", res?.token);
          localStorage.setItem("refreshToken", res?.refreshToken);
          setIsOtpInputEnable(false);
        } else {
          toast?.error(
            res?.data?.message || res?.data?.error || "Something went wrong"
          );
        }
      }
    },
  });

  return (
    <div>
      <div className="grid grid-cols-12 gap-6 py-6 xls:pr-10">
        <div className="col-span-12 flex flex-col">
          <form onSubmit={(e) => handleSubmit(e, mutate)} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6  items-center justify-center">
              <div>
                <Input
                  label={"New Email"}
                  inputType={"email"}
                  value={values?.email}
                  inputPlaceholder={"Enter email"}
                  inputName="email"
                  onChange={handleChange}
                  required={true}
                  isValidate={true}
                  isDisabled={isOtpInputEnable}
                  inputClasses={"!h-11 md:!h-10"}
                  labelClasses={"!text-xs !text-slate-600"}
                  {...formValidate(errors, "email")}
                />
              </div>
              {isOtpInputEnable ? (
                <div>
                  <div>
                    <Input
                      label={"One-Time Passcode"}
                      inputType={"number"}
                      value={values?.otp}
                      inputPlaceholder={"Enter the code to confirm"}
                      inputName="otp"
                      onChange={handleChange}
                      required={true}
                      isValidate={true}
                      inputClasses={"!h-11 md:!h-10"}
                      labelClasses={"!text-xs !text-slate-600"}
                      {...formValidate(errors, "otp")}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <Button
                    buttonLabel={"Send One-Time Passcode"}
                    buttonClasses={
                      "!rounded-full !px-8 hover:!bg-chestnut-rose text-white h-8 !bg-chestnut-rose hover:!bg-red-600 mt-3"
                    }
                    buttonLabelClasses={"mx-auto !text-xs lg:!text-base"}
                    loading={otpLoding}
                    isDisable={otpLoding}
                    buttonType={"submit"}
                  />
                </div>
              )}
            </div>
            {isOtpInputEnable && (
              <div className=" flex items-center justify-end">
                <Button
                  buttonType={"submit"}
                  buttonIcon={"fa-light fa-floppy-disk"}
                  buttonIconPosition={"left"}
                  buttonLabel="Save"
                  // loading={profileLoding}
                  // isDisable={profileLoding}
                  buttonLabelClasses={"!text-sm"}
                  buttonClasses="!py-2 !px-2 rounded-lg text-white !h-auto !bg-chestnut-rose hover:!bg-red-600"
                />
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangeEmail;
